const types = {
  alertToggle: 'ALERT_TOGGLE',
  loginSuccess: 'LOGIN_SUCCESS',
  loginFailure: 'LOGIN_FAILURE',
  logoutSuccess: 'LOGOUT_SUCCESS',
  logoutFailure: 'LOGOUT_FAILURE',
  refresh: 'REFRESH',
  request: 'REQUEST',
  fetchData: 'FETCH_DATA',
  receiveSuccess: 'RECEIVE_SUCCESS',
  receiveFailure: 'RECEIVE_FAILURE',
  basicDic: 'BASIC_DIC',
  searchIndex: 'SEARCH_INDEX',
  searchUser: 'SEARCH_USER',
  searchChangeType: 'SEARCH_CHANGE_TYPE',
  switcherHide: 'SWITCHER_HIDE',
  switcherShow: 'SWITCHER_SHOW',
  setKeyTypes:'SETKEYTYPES',
  signNotice:'SIGN_NOTICE',
  themeColor: 'THEME_COLOR',
  openNewTab: 'OPEN_NEW_TAB',
  setInfoCenterShow: 'SET_INFO_CENTER_SHOW',
  setDeviceList: 'SET_DEVICE_LIST',
  setIsKeyLogin: 'SET_IS_KEY_LOGIN',
  recordLog:'SEARCH_LOG',
  setIsVerifyControlPersonOperation: 'SET_IS_VERIFY_CONTROL_PERSON_OPERATION',
  setAreaList: 'SET_AREA_LIST',
  statisticalTableData: 'STATISTICAL_TABLE_DATA',
  setFirstType:'SET_FIRST_TYPE',
  //IDC参数
  SET_MENUS: 'SET_MENUS',
  SET_ORIGIN_MENUS: 'SET_ORIGIN_MENUS',
  SET_ACTIVE_MENU: 'SET_ACTIVE_MENU',
  // 用于设置返回上一级路由的状态
  SET_BACKUP_STATE: 'SET_BACKUP_STATE',
  // 用于设置传到下一级路由的参数
  SET_ROUTE_PARAMS: 'SET_ROUTE_PARAMS',
  // 设置系统名称
  SET_TITLE: 'SET_TITLE',
  // 设置初始化的tab页
  SET_IS_TAB_INIT: 'SET_IS_TAB_INIT',
  // 设置主题
  SET_THEME: 'SET_THEME',
  SET_USER: 'SET_USER',
  SET_AREAS: 'SET_AREAS',
  SET_LOGO: 'SET_LOGO' // 设置系统LOGO'
};
export default types;
